export const DICTIONARY_COUNTRIES = "iso-3166-2";
export const DICTIONARY_TOURISM_OBJECT_TYPES = "tourism-object-category";
export const DICTIONARY_VAT_CATEGORIES = "VAT_DICTIONARY";
export const DICTIONARY_PRODUCT_CODE_REALIZATION_PLACE =
  "PRODUCT_CODE_REALIZATION_PLACE";
export const DICTIONARY_PRODUCT_PARENT_LOCATION = "PARENT_LOCATION";
export const DICTIONARY_PROVINCES = "pl-provinces";
